import { render } from "./Video-Row.vue?vue&type=template&id=1e5ea2ab"
import script from "./Video-Row.vue?vue&type=script&lang=js"
export * from "./Video-Row.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__